import CalendarStore from './calendarStore.js'
import CalendarMain from './CalendarMain.vue'
import TableColumn from './TableColumn.vue'
import ConfirmationModal from './ConfirmationModal.vue'
import EditReservationModal from './EditReservationModal.vue'
import ListReservationsModal from './ListReservationsModal.vue'
import ReservationsList from './ReservationsList.vue'

const components = {
    CalendarMain,
    TableColumn,
    ConfirmationModal,
    EditReservationModal,
    ListReservationsModal,
    ReservationsList,
}

export default {
    install(app, { store }) {
        Object.keys(components).forEach((name) => {
            const component = components[name];

            app.component(name, component);
        })
        
        
        if (typeof store !== 'undefined') {
            store.registerModule('calendar', CalendarStore)
        }
    }
}